import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { AlbumCard } from "@/components/cards/AlbumCard";
import { ArtistCard } from "@/components/cards/ArtistCard";
import { PlaylistCard } from "@/components/cards/PlaylistCard";
import { SectionShelf } from "@/components/shelf/SectionShelf";
import { TrackList } from "@/components/tracks/TrackList";
import { useDebounce } from "@/hooks/useDebounce";
import { searchService } from "@/services/searchService";
import type { SearchResults } from "@/types/types";

export function SearchPage() {
  const [params] = useSearchParams();
  const q = useDebounce(params.get("q") ?? "", 250);
  const [res, setRes] = useState<SearchResults | null>(null);
  useEffect(() => {
    if (!q) { setRes(null); return; }
    searchService.search(q).then(setRes).catch(console.error);
  }, [q]);
  if (!q) return <p className="muted">Tapez quelque chose là-haut pour chercher…</p>;
  if (!res) return null;
  return (
    <div>
      <h1>Résultats pour « {q} »</h1>
      {res.tracks.length > 0 && <section style={{ marginBottom: 24 }}><h2>Morceaux</h2><TrackList tracks={res.tracks} /></section>}
      {res.artists.length > 0 && <SectionShelf title="Artistes">{res.artists.map((a) => <ArtistCard key={a.id} artist={a} />)}</SectionShelf>}
      {res.albums.length > 0 && <SectionShelf title="Albums">{res.albums.map((a) => <AlbumCard key={a.id} album={a} />)}</SectionShelf>}
      {res.playlists.length > 0 && <SectionShelf title="Playlists">{res.playlists.map((p) => <PlaylistCard key={p.id} playlist={p} />)}</SectionShelf>}
    </div>
  );
}
